import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { CognitoService } from '../core/services/cognito.service';
import { Router } from '@angular/router';
import { ProgramService } from '../core/services/program.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];
  selectedProgramId: number = 0;
  showLimitedMenu: boolean = true;
  showBackToGlobalMenuModal: boolean = false;

  constructor(
    public layoutService: LayoutService,
    private readonly cognitoService: CognitoService,
    private readonly router: Router,
    private programService: ProgramService
  ) { }

  ngOnInit() {
    this.programService.programId$.subscribe(id => {
      this.selectedProgramId = id;
      this.showLimitedMenu = this.selectedProgramId === 0;
      this.buildMenu();
    });
  }
  buildMenu() {
    this.cognitoService.getCurrentUserRoles().then((roles: string) => {
      if (roles.includes('admin')) {
        if (this.showLimitedMenu) {
          this.model = [
            {
              items: [
                { label: 'Venue Management', icon: 'pi pi-database', routerLink: ['/venue-management'] },
                { label: 'Prog. Managem.', icon: 'pi pi-flag-fill', routerLink: ['/program-management'] },
                {
                  label: 'Site Settings',
                  icon: 'pi pi-calendar',
                  items: [
                    { label: 'Media Configuration', icon: 'pi pi-image', routerLink: ['/media-configuration'] },
                    { label: 'Content Editor', icon: 'pi pi-pencil', routerLink: ['/content-editor'] }
                  ],
                },
                {
                  label: 'Users',
                  icon: 'pi pi-users',
                  items: [
                    { label: 'Regular Admins', icon: 'pi pi-user-plus', routerLink: ['/users'] },
                    { label: 'Ticket Checkers', icon: 'pi pi-ticket', routerLink: ['/ticket-checker'] },
                    { label: 'Seller Agents', icon: 'pi pi-briefcase', routerLink: ['/agent-user'] },
                    { label: 'Ticket Operators', icon: 'pi pi-user', routerLink: ['/ticket-operator'] },
                  ],
                },
                { label: 'Activity Log', icon: 'pi pi-history', routerLink: ['/activity-log'] }
              ],
            },
          ];
        } else {
          this.model = [
            {
              items: [
                { label: 'Dashboard', icon: 'pi pi-th-large', routerLink: ['/'] },
                { label: 'Events', icon: 'pi pi-calendar', routerLink: ['/events'] },
                { label: 'Ticket Counter', icon: 'pi pi-print', routerLink: ['/ticket-counter'] },
                { label: 'Generate Tickets', icon: 'pi pi-check', routerLink: ['/events/event-ticket'] },
                {
                  label: 'Batch',
                  icon: 'pi pi-box',
                  items: [
                    { label: "Assignments", icon: "pi pi-align-justify", routerLink: ['/batch-management/assignment'], activeMatchPaths: ['/batch-management/assignment'] },
                    { label: 'Batch List', icon: 'pi pi-calendar-plus', routerLink: ['/batch-management/bach-list'] },
                  ]
                }, 
                {
                  label: 'Reports',
                  icon: 'pi pi-chart-pie',
                  items: [
                    { label: 'Booking Orders', icon: 'pi pi-cart-plus', routerLink: ['/report/booking-orders'] },
                    { label: 'Payment Discrepancy', icon: 'pi pi-exclamation-triangle', routerLink: ['/report/payment-discrepancy'] },
                    {
                      label: 'Ticket Checker',
                      icon: 'pi pi-check-circle',
                      items: [
                        { label: 'Detailed Checker', icon: 'pi pi-file', routerLink: ['/report/checker'] },
                        { label: 'Duplicate Entry Count', icon: 'pi pi-clone', routerLink: ['/report/ticket-duplicate'] },
                        { label: 'Pass Checker Report', icon: 'pi pi-id-card', routerLink: ['/report/pass-checker'] }
                      ],
                    },
                    {
                      label: 'Batch Report',
                      icon: 'pi pi-box',
                      items: [
                        { label: 'Batch Report', icon: 'pi pi-box', routerLink: ['/report/batch-report'] },
                      ],
                    },
                    {
                      label: 'Sales Report',
                      icon: 'pi pi-chart-bar',
                      items: [
                        { label: 'Event-Wise Sales', icon: 'pi pi-calendar-plus', routerLink: ['/report/event-wise-sales'] },
                        { label: 'Summary Sales', icon: 'pi pi-table', routerLink: ['/report/summary-sales'] },
                      ],
                    },
                    {
                      label: 'Revenue Report',
                      icon: 'pi pi-chart-line',
                      items: [
                        { label: 'Day-wise Revenue', icon: 'pi pi-calendar', routerLink: ['/report/day-wise-revenue'] },
                        { label: 'Event-wise Revenue', icon: 'pi pi-ticket', routerLink: ['/report/event-wise-revenue'] },
                        { label: 'Summary Revenue', icon: 'pi pi-list', routerLink: ['/report/summary-revenue'] },
                      ],
                    },
                  ],
                },
                {
                  label: 'Promo & Discount',
                  icon: 'pi pi-percentage',
                  items: [
                    { label: 'Promo', icon: 'pi pi-shopping-bag', routerLink: ['/promo-management/promo'], activeMatchPaths: ['/promo-management/promo', '/promo-management/create', '/promo-management/edit-promo'] },
                    { label: 'Discount', icon: 'pi pi-shopping-bag', routerLink: ['/promo-management/discount'], activeMatchPaths: ['/promo-management/discount', '/promo-management/discount/create-discount', '/promo-management/discount/edit-discount'] },
                  ],
                },
                { label: 'Issues', icon: 'pi pi-exclamation-triangle', routerLink: ['/issues'] },
                // { label: 'Notifications', icon: 'pi pi-bell' },
                // { label: 'Settings', icon: 'pi pi-cog' },
              ],
            },
          ];
        }
      }
      else if (roles.includes('customer_support')) {
        if (this.showLimitedMenu) {
          this.model = [
            {
              items: [
                { label: 'Home', icon: 'pi pi-home', routerLink: ['/home'] },
              ],
            },
          ];
        } else {
          this.model = [
            {
              items: [
                { label: 'Issues', icon: 'pi pi-exclamation-triangle', routerLink: ['/issues'] },
              ],
            },
          ];
        }
      }
      else if (roles.includes('event_manager') && roles.includes('ticket_manager')) {
        if (this.showLimitedMenu) {
          this.model = [
            {
              items: [
                { label: 'Venue Management', icon: 'pi pi-database', routerLink: ['/venue-management'] },
                { label: 'Prog. Managem.', icon: 'pi pi-flag-fill', routerLink: ['/program-management'] },
                {
                  label: 'Site Settings',
                  icon: 'pi pi-calendar',
                  items: [
                    { label: 'Media Configuration', icon: 'pi pi-image', routerLink: ['/media-configuration'] },
                    { label: 'Content Editor', icon: 'pi pi-pencil', routerLink: ['/content-editor'] },
                  ],
                }
              ],
            },
          ];
        } else {
          this.model = [
            {
              items: [
                { label: 'Events', icon: 'pi pi-calendar', routerLink: ['/events'] },
                { label: 'Ticket Counter', icon: 'pi pi-print', routerLink: ['/ticket-counter'] },
                { label: 'Generate Tickets', icon: 'pi pi-check', routerLink: ['/events/event-ticket'] },               
                {
                  label: 'Batch',
                  icon: 'pi pi-box',
                  items: [
                    { label: "Assignments", icon: "pi pi-align-justify", routerLink: ['/batch-management/assignment'], activeMatchPaths: ['/batch-management/assignment'] },
                    { label: 'Batch List', icon: 'pi pi-calendar-plus', routerLink: ['/batch-management/bach-list'] },
                  ]
                }, 
              ],
            },
          ];
        }
      }
      else if (roles.includes('ticket_manager')) {
        if (this.showLimitedMenu) {
          this.model = [
            {
              items: [
                { label: 'Home', icon: 'pi pi-home', routerLink: ['/home'] },
              ],
            },
          ];
        } else {
          this.model = [
            {
              items: [
                { label: 'Ticket Counter', icon: 'pi pi-print', routerLink: ['/ticket-counter'] },
                { label: 'Generate Ticket', icon: 'pi pi-check', routerLink: ['/events/event-ticket'] },
                {
                  label: 'Batch',
                  icon: 'pi pi-box',
                  items: [
                    { label: "Assignments", icon: "pi pi-align-justify", routerLink: ['/batch-management/assignment'], activeMatchPaths: ['/batch-management/assignment'] },
                    { label: 'Batch List', icon: 'pi pi-calendar-plus', routerLink: ['/batch-management/bach-list'] },
                  ]
                }, 
              ],
            },
          ];
        }
      }
      else if (roles.includes('ticket_operator')) {
        if (this.showLimitedMenu) {
          this.model = [
            {
              items: [
                { label: 'Home', icon: 'pi pi-home', routerLink: ['/home'] },
              ],
            },
          ];
        } else {
          this.model = [
            {
              items: [
                { label: 'Dashboard', icon: 'pi pi-th-large', routerLink: ['/'] },

                { label: 'Ticket Counter', icon: 'pi pi-print', routerLink: ['/ticket-counter'] },
                { label: 'Generate Ticket', icon: 'pi pi-check', routerLink: ['/events/event-ticket'] },
                {
                  label: 'Reports',
                  icon: 'pi pi-chart-pie',
                  items: [
                    { label: 'Booking Orders', icon: 'pi pi-cart-plus', routerLink: ['/report/booking-orders'] },
                    { label: 'Payment Discrepancy', icon: 'pi pi-exclamation-triangle', routerLink: ['/report/payment-discrepancy'] },
                    {
                      label: 'Ticket Checker',
                      icon: 'pi pi-check-circle',
                      items: [
                        { label: 'Detailed Checker', icon: 'pi pi-file', routerLink: ['/report/checker'] },
                        { label: 'Duplicate Entry Count', icon: 'pi pi-clone', routerLink: ['/report/ticket-duplicate'] },
                      ],
                    },
                    {
                      label: 'Sales Report',
                      icon: 'pi pi-chart-bar',
                      items: [
                        { label: 'Event-Wise Sales', icon: 'pi pi-calendar-plus', routerLink: ['/report/event-wise-sales'] },
                        { label: 'Summary Sales', icon: 'pi pi-table', routerLink: ['/report/summary-sales'] },
                      ],
                    },
                    {
                      label: 'Revenue Report',
                      icon: 'pi pi-chart-line',
                      items: [
                        { label: 'Day-wise Revenue', icon: 'pi pi-calendar', routerLink: ['/report/day-wise-revenue'] },
                        { label: 'Event-wise Revenue', icon: 'pi pi-ticket', routerLink: ['/report/event-wise-revenue'] },
                        { label: 'Summary Revenue', icon: 'pi pi-list', routerLink: ['/report/summary-revenue'] },
                      ],
                    },
                  ],
                },
              ],
            },
          ];
        }
      }
      else if (roles.includes('event_manager')) {
        if (this.showLimitedMenu) {
          this.model = [
            {
              items: [
                { label: 'Venue Management', icon: 'pi pi-database', routerLink: ['/venue-management'] },
                { label: 'Prog. Managem.', icon: 'pi pi-flag-fill', routerLink: ['/program-management'] },
                {
                  label: 'Site Settings',
                  icon: 'pi pi-calendar',
                  items: [
                    { label: 'Media Configuration', icon: 'pi pi-image', routerLink: ['/media-configuration'] },
                    { label: 'Content Editor', icon: 'pi pi-pencil', routerLink: ['/content-editor'] },
                  ],
                }
              ],
            },
          ];
        } else {
          this.model = [
            {
              items: [
                { label: 'Events', icon: 'pi pi-calendar', routerLink: ['/events'] },
              ],
            },
          ];
        }
      }
    });
  }
  onBackToGlobalMenuClick() {
    this.showBackToGlobalMenuModal = true;
  }

  leaveToGlobalMenu() {
    this.showBackToGlobalMenuModal = false;
    this.programService.setProgramId(0);
    //this.router.navigate(['/program-management']);
    this.cognitoService.getCurrentUserRoles().then((role: string) => {
      //let desireRoute = '/';
      let targetRoute = '/program-management';

      if (role.includes('admin')) {
        targetRoute = '/program-management';
      } else if (role.includes('customer_support')) {
        targetRoute = '/home';
      } else if (role.includes('event_manager') && role.includes('ticket_manager')) {
        targetRoute = '/program-management';
      } else if (role.includes('ticket_manager')) {
        targetRoute = '/program-management';
      } else if (role.includes('ticket_operator')) {
        targetRoute = '/home';
      } else if (role.includes('event_manager')) {
        targetRoute = '/program-management';
      }

      this.router.navigate([targetRoute]);
    });

  }
}
